import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function customerReducer(state = initialState.customers, action) {
    let newState = state;

    switch (action.type) {
        case types.LOAD_CUSTOMERS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    customers: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_CUSTOMER_STATE:
            return Object.assign({}, state, {
                loading: true
            });
        case types.SYNC_CUSTOMERS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/customerReducer.js
 **/